import React,{useEffect, useState}  from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {HiOutlineLocationMarker} from 'react-icons/hi'

const cityDetail= [
    {
        City:"Delhi",
        airport:"DEL Delhi Airport India"
    },
    {   City:"Mumbai",
        airport:"BOM Chatrapati Shivaji Airport"
    },
    {   City:"Goa",
        airport:"GOI Goa Dabolim International Airport"
    },
    {   City:"Kolkata",
        airport:"CCU Netaji S.C. Bose International Airport"
    },
    {   City:"Banglore",
        airport:"BLR Bengaluru International Airport"
    },
    {   City:"Chennai",
        airport:"MAA Chennai International Airport"
    }
]

export default function FlightMenu(props) {
  const [selectCity, setSelectCity] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCity = (e)=>{
    setSelectCity(e.target.id);
  }
  useEffect(()=>{
    if(!selectCity){
      return;
    }
    const tempArrObj = cityDetail.filter(elem=>elem.City===selectCity);
    props.setterFunc(tempArrObj[0]);
    props.removeMenu(false);
    setAnchorEl(null);
  }, [selectCity])

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{color: 'red', fontSize:'40px', width:'80vw', height:'150px', backgroundColor:'transparent'}}
      >
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {cityDetail.map(el=>{
            return <MenuItem onClick={handleCity} sx={{width:'max-content', display:'flex',alignItems:'baseline', flexDirection:'column', backgroundColor:'#f3f3f3', marginBottom:'10px', width:'100%'}} id={el.City} key={el.City}>
            <MenuItem id={el.City}>
            <HiOutlineLocationMarker />{el.City}
            </MenuItem>
            <br />
            <MenuItem id={el.City} sx={{textOverflow:'break-word'}}>{el.airport}</MenuItem>
            </MenuItem>
        })
        }
      </Menu>
    </div>
  );
}